import { createActionCreator } from 'deox';

export const uiActions = {
  setDevice: createActionCreator('SET_DEVICE_ACTION', (resolve) => (deviceWidth: number) => resolve({ deviceWidth })),
  persistCoordinate: createActionCreator(
    'PERSIST_COORDINATE_ACTION',
    (resolve) => (pathname: string, coordinate: { x: number; y: number }) => resolve({ pathname, coordinate })
  ),
  persistViewMode: createActionCreator('PERSIST_VIEW_MODE_ACTION', (resolve) => (pathname: string, viewMode: string) =>
    resolve({ pathname, viewMode })
  ),
  setOpenSubscribePopup: createActionCreator('SET_OPEN_SUBSCRIBE_POPUP', (resolve) => (openedSubscribePopup: boolean) =>
    resolve({ openedSubscribePopup })
  ),
};
